import React, { Fragment } from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import CardMedia from "@material-ui/core/CardMedia"
import Typography from "@material-ui/core/Typography"
import classnames from "classnames"
import CountUp from "components/CountUp"
import { Chip } from "@material-ui/core"

const Item = ({ classes, item, hidden, showBidderInfo, nameStyle }) => {
  const getChipLabel = item => {
    if (item.item_type === "auction" && item.live_auction) {
      return "Live Auction"
    } else {
      return item.item_type
    }
  }
  const minBidAmount = () => {
    if (item.high_bid) {
      return item.high_bid + item.bid_increment
    } else {
      return item.reserve
    }
  }
  const numberAreaTitle = () => {
    if (item.item_type === "auction") {
      if (showBidderInfo) {
        if (item.high_bid) {
          return item.high_bid_data.high_bid_user_name
        } else {
          // item.high_bid === 0
          return "Current Bid"
        }
      } else {
        // showBidderInfo === false
        return "Current Bid"
      }
    } else if (item.item_type === "raffle") {
      return "Tickets"
    } else if (item.item_type === "fixed") {
      if(item.cost === 0){
        return "Votes"
      }else{
        return "Price"
      }
    }
  }

  const itemSales =() => {
    if(item.item_sales === ""){
      return 0
    }else{
      return item.item_sales
    }
  }

  return (
    <Card
      className={classnames(classes.card, {
        [classes.cardHidden]: hidden
      })}
    >
      <CardMedia
        component="div"
        alt={item.name}
        className={classes.media}
        image={item.image[0] ? item.image[0].url : ""}
        title={item.name}
      >
        <Chip
          label={getChipLabel(item)}
          className={classnames(
            classes.chip,
            classes[`${[item.item_type]}Chip`],
            {
              [classes.liveChip]:
                item.item_type === "auction" && item.live_auction
            }
          )}
        />
      </CardMedia>
      <CardContent className={classes.cardRoot}>
        <div className={classes.cardTop}>
          <Typography className={classes.cardTitle} component="">
            {item.name}
          </Typography>
          {item.donor && (
            <Typography component="p" className={classes.donor}>
              Donated By{" \n"}
              <Typography component="span" className={classes.donorName}>
                {item.donor}
              </Typography>
            </Typography>
          )}
        </div>
        <div className={classes.cardBottom}>
          <Typography
            className={classes.itemCode}
            component="span"
            variant="h4"
          >
            {item.item_code}
          </Typography>
          <div className={classes.numbersArea}>
            {item.item_type === "auction" && !item.live_auction &&(
              <Fragment>
                <Typography
                  className={classes.numbersAreaTitle}
                  component="span"
                >
                  {numberAreaTitle()}
                </Typography>
                <Typography
                  className={classes.numbersAreaNumber}
                  component="span"
                >
                  <CountUp
                    end={minBidAmount()}
                    start={minBidAmount()}
                    duration={1}
                    prefix="$"
                  />
                </Typography>
              </Fragment>
            )}
            {item.item_type === "raffle" && (
              <Fragment>
                <Typography
                  className={classes.numbersAreaTitle}
                  component="span"
                >
                  {numberAreaTitle()}
                </Typography>
                <Typography
                  className={classes.numbersAreaNumber}
                  component="span"
                >
                  ${item.raffle_price}
                </Typography>
              </Fragment>
            )}
            {item.item_type === "fixed" && (
              <Fragment>
                <Typography
                  className={classes.numbersAreaTitle}
                  component="span"
                >
                  {numberAreaTitle()}
                </Typography>
                <Typography
                  className={classes.numbersAreaNumber}
                  component="span"
                >
                  ${item.cost === 0 ? itemSales() : item.cost}
                </Typography>
              </Fragment>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export default withStyles(styles, { withTheme: true })(Item)



// WEBPACK FOOTER //
// ./src/components/Item/index.jsx